// extracted by mini-css-extract-plugin
export default {"containerDash":"controller-link-modal_containerDash__-Gw9p"};